// extracted by mini-css-extract-plugin
export default {"left-section":"LeftSection_left-section__8JyuS","header":"LeftSection_header__MyW1T","list-item":"LeftSection_list-item__Pmr6g","phone-number":"LeftSection_phone-number__yofdP"};